var map = {
	"./badge_deios_bronze.png": "055a",
	"./badge_deios_gold.png": "78ef",
	"./badge_deios_helping_fairy.png": "8964",
	"./badge_deios_lifetime.png": "0815",
	"./badge_deios_lifetime_cl.png": "4049",
	"./badge_deios_platinum.png": "ec6a",
	"./badge_deios_platinum_cl.png": "f038",
	"./badge_deios_silver.png": "a079",
	"./caeora.png": "e1ed",
	"./img_app_preview_linux.png": "6e06",
	"./img_app_preview_mac.png": "6500",
	"./img_app_preview_win.png": "f565",
	"./img_assetpack_artefacts.jpg": "39c4",
	"./img_assetpack_base.jpg": "2c29",
	"./img_assetpack_carcasses.jpg": "0d37",
	"./img_assetpack_dwarven.jpg": "c510",
	"./img_assetpack_elven.jpg": "6aca",
	"./img_assetpack_evillairs.jpg": "cc7c",
	"./img_assetpack_lovecraft.jpg": "4d47",
	"./img_assetpack_orcish.jpg": "cc1d",
	"./img_assetpack_titaniccreatures.jpg": "ae11",
	"./img_assetpack_wonders.jpg": "3250",
	"./img_badge_unlocked.png": "5eea",
	"./img_deios_background.png": "897a",
	"./img_deios_roadmap.webp": "7be8",
	"./img_delay_decoration_bottom.png": "31da",
	"./img_delay_decoration_top.png": "8240",
	"./img_emptystate_chest.png": "4d50",
	"./img_footer_background.png": "974f",
	"./img_header_background.jpg": "50ee",
	"./img_header_desert.jpg": "c7c6",
	"./img_header_forest.jpg": "60d1",
	"./img_header_vulcano.jpg": "bae6",
	"./img_legende_included.png": "ae59",
	"./img_legende_locked.png": "4946",
	"./img_legende_sub.png": "6ba2",
	"./img_legende_unlocked.png": "5e37",
	"./img_membership_commercial.png": "2446",
	"./img_membership_commercial_lifetime.png": "e0d7",
	"./img_membership_greatgm_masterclass.png": "9bc6",
	"./img_membership_key_standalone.png": "7b6d",
	"./img_membership_lifetime.png": "8bfc",
	"./img_membership_sub_12.png": "bd77",
	"./img_membership_sub_15m.png": "a436",
	"./img_membership_sub_21m.png": "d4f6",
	"./img_membership_sub_27m.png": "089d",
	"./img_membership_sub_6m.png": "5f25",
	"./img_membership_sub_9m.png": "3939",
	"./img_preorder_background.png": "e166",
	"./img_preorder_standalone.png": "94ff",
	"./img_preorder_standalone_with_premium.png": "dac9",
	"./img_sectionheader_bottombar.png": "fde0",
	"./img_sectionheader_topbar.png": "abc8",
	"./img_setting_age_of_exploration.png": "7859",
	"./img_setting_basefantasy.png": "d828",
	"./img_setting_cyberpunk.png": "27da",
	"./img_setting_deadhaussonata.png": "1ec2",
	"./img_setting_highfantasy.png": "65c6",
	"./img_setting_lostciv.png": "a7cc",
	"./img_setting_solar_systems_and_galaxies.png": "551a",
	"./img_setting_spacetravel.png": "dd9c",
	"./img_setting_underdark.png": "70bd",
	"./img_setting_wondorousempires.png": "c977",
	"./img_timeline.webp": "ac61",
	"./img_timeline_mobile.webp": "14c8",
	"./logo.png": "4ffd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";